module.exports = __webpack_public_path__ + "static/img/200156.2f27bafb.png";